import { BaseEntity } from 'src/app/tools/models/baseEntity';

export class CancelationReason extends BaseEntity{
    
    cancelationReasonCode : string;
    name : string;
}
